module.exports = __webpack_public_path__ + "img/no_image_bg.c955a626.svg";